import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import _ from 'i18n';
import { setCurrentNavPage } from 'actions';
import lottie from 'lottie-web';
import { S3_FOLDER_URL_PROD } from 'Config';

const HomePage = (props) => {
  const { application, dispatch } = props;
  const anim = useRef(null);
  const animationContainerRef = useRef(null);

  useEffect(() => {
    dispatch(setCurrentNavPage("HOME"));
    intiAnimation();
  }, []);

  useEffect(() => {
    intiAnimation();
  }, [application]);

  const intiAnimation = () => {
    if (anim.current) {
      anim.current.destroy();
    }
    anim.current = lottie.loadAnimation({
      container: animationContainerRef.current,
      renderer: 'svg',
      loop: 1,
      autoplay: true,
      path: `${S3_FOLDER_URL_PROD}/emailing/assets/animations/${application || "emailing"}-header.json`,
    });
  };

  const handleClickToPause = () => {
    if (!anim.current) return;
    if (anim.current.isPaused) {
      anim.current.goToAndPlay(0);
    } else {
      anim.current.pause();
    }
  };

  const renderTitle = (application) => {
    switch (application) {
      case 'emailing':
        return (
          <div className="sending-header__title">
            <h3>{_("Send your emailings")}</h3>
            <h4>{_("to the look & feel of your community")} <span>{_("with little effort!")}</span></h4>
          </div>
        );
      case 'sms':
        return (
          <div className="sending-header__title">
            <h3>{_("Send your sms campaigns")}</h3>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="home-page" id="home-page">
      <div className="sending-header">
        {renderTitle(application)}
        <div className="sending-header__animation" ref={animationContainerRef} onClick={handleClickToPause} />
        <video controls poster={`/img/pictos/${application}-poster.jpg`}>
          <source src={`${S3_FOLDER_URL_PROD}/emailing/assets/${application}.mp4`} type="video/mp4" />
        </video>
      </div>
    </div>
  );
};

export default connect((store) => ({
  application: (store.params.application || 'EMAILING').toLocaleLowerCase(),
}))(HomePage);
